import React from 'react';
import { useTranslation } from 'react-i18next';

import IconCheck from '@/assets/icons/heroIcons/Circle-check.svg';

export function SuccessMessage({ isRefund }: { isRefund: boolean }): React.JSX.Element {
	const { t } = useTranslation('personalDataRequests');

	return (
		<div>
			<IconCheck className="mx-auto h-10 w-10 lg:h-16 lg:w-16" />
			{isRefund ? (
				<>
					<h3 className="my-6 text-center text-lg font-bold lg:text-4xl">{t('success.title')}</h3>

					<p className="mb-6 text-base font-semibold lg:text-xl">{t('success.subtitle')}</p>

					<ul className="mb-8 list-disc space-y-2 pl-5 marker:text-blue-500 lg:mb-12">
						<li>{t('success.refund.1')}</li>
						<li>{t('success.refund.2')}</li>
						<li>{t('success.refund.3')}</li>
					</ul>
				</>
			) : (
				<>
					<h3 className="my-6 text-center text-lg font-bold lg:text-4xl">{t('success.title')}</h3>

					<p className="mb-6 text-base font-semibold lg:text-xl">{t('success.subtitle')}</p>

					<ul className="mb-8 list-disc space-y-2 pl-5 marker:text-blue-500 lg:mb-12">
						<li>{t('success.list.1')}</li>
						<li>{t('success.list.2')}</li>
						<li>{t('success.list.3')}</li>
					</ul>
				</>
			)}
		</div>
	);
}
